/**
 * @generated SignedSource<<90734b8f56cf6e324031d9b5c261a459>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiImageGenEditor_Query$variables = Record<PropertyKey, never>;
export type aiImageGenEditor_Query$data = {
  readonly imageGeneration: {
    readonly categoriesForGeneration: ReadonlyArray<number>;
    readonly id: string;
    readonly numberOfImagesEdit: number;
    readonly numberOfImagesGeneration: number;
    readonly serviceIDEdit: number | null;
    readonly serviceIDGeneration: number | null;
  } | null;
  readonly imageGenerationPresetCategories: ReadonlyArray<{
    readonly categoryID: number;
    readonly name: string;
  }>;
};
export type aiImageGenEditor_Query = {
  response: aiImageGenEditor_Query$data;
  variables: aiImageGenEditor_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationDTO",
    "kind": "LinkedField",
    "name": "imageGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceIDGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceIDEdit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesEdit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesForGeneration",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationPresetCategoryInfoDTO",
    "kind": "LinkedField",
    "name": "imageGenerationPresetCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7dcfeeefc9f173191cfdeb22eee6f34c",
    "id": null,
    "metadata": {},
    "name": "aiImageGenEditor_Query",
    "operationKind": "query",
    "text": "query aiImageGenEditor_Query {\n  imageGeneration {\n    id\n    serviceIDGeneration\n    serviceIDEdit\n    numberOfImagesGeneration\n    numberOfImagesEdit\n    categoriesForGeneration\n  }\n  imageGenerationPresetCategories {\n    categoryID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "290e0894b5861bdb227187c88b3edefd";

export default node;
